// https://github.com/Wikia/unified-platform/blob/2e85347cf97b506e10cbf263d0d843c4f0ff7256/extensions/fandom/Track/templates/tracking-cookies.mustache
/** Non-RFC compliant UUID */
export default function genUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
